import { lazy } from 'react';

/**
 * AIVA loaded at runtime from the Module Federation remote (wired in
 * config-overrides.js, URL per environment via REACT_APP_AIVA_REMOTE_URL).
 * Shared by the legacy (`components/Aiva`) and new Unify (`v2/third-party-integration/aiva`)
 * wrappers so a single chunk/remote instance backs both. Must be rendered inside a
 * <Suspense> boundary; both call sites are already wrapped in an ErrorBoundary.
 */
export const Aiva = lazy(() => import('Aiva/App'));